import React from 'react';
import '../RequirementsAdmin/Loader.css'
export default function Spinner() {
    return (
        <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    )
}